export default __webpack_public_path__ + "static/media/relative-book-pro.c2a7f843.ttf";